import React from 'react';
import styled from 'styled-components';
import {getOutlet} from 'reconnect.js';
import {Button, Result, Space} from 'antd';
import Config from '../../../data.json';

const LoginRequired = (options) => {
  const {admin, layout} = options;

  return (
    <Wrapper admin={admin}>
      <Result
        icon={<img src={Config.loginRequiredImage} alt="permission-denied" />}
        title={Config.loginRequiredTitle}
        subTitle={Config.loginRequiredSubtitle}
        extra={
          <Space direction="vertical">
            <Button
              onClick={() => {
                const loginModal = getOutlet('login-modal');
                loginModal.update({admin});
              }}>
              {Config.loginRequiredButtonText}
            </Button>
          </Space>
        }
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  min-height: ${({admin}) => (admin ? '100vh;' : 'var(--contentMinHeight);')}
  padding-top: var(--topNavBarHeight);
  display: flex;
  align-items: center;
  justify-content: center;
  & img {
    width: 150px
  }
`;

export default LoginRequired;
